import React, {Component} from 'react';
import {Button, Skeleton} from "antd";
import {getLeasingStatus} from "../../appRedux/actions";
import {connect} from "react-redux";
import './style.css';

const label = {
    'OPEN': 'Available',
    'CLOSED': 'Under Lease',
    'BLOCKED': 'Blocked',
    'EXPIRED': 'Expired',
    '': '-',
    'NaN': '',
    undefined: '',
    null: ''
}

class Status extends Component {
    constructor(props) {
        super(props);
        this.statusArray = {'': 'dashed', 'EXPIRED': 'danger', 'CLOSED': 'error', 'OPEN': 'primary'};
        this.state = {
            status: {},
            load: {},
            contract: {},
            cachedStatus: null
            // color: 'primary',

        }
    }

    componentDidMount() {
        if (this.props.id) {
            const allStatus = this.props.allStatus;
            if (!allStatus[this.props.id])
                this.props.getLeasingStatus(this.props.id);
            else {
                this.setState({
                    cachedStatus: allStatus[this.props.id]
                })
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // console.log('here', nextProps.status)
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.cachedStatus && prevProps.status !== this.props.status) {
            // console.log('3. ', prevProps, this.props);
            let st = this.state.status;
            let ld = this.state.load;
            let con = this.state.contract;
            if (this.props.status !== null && this.props.status.status !== null) {
                st[this.props.status.id] = this.props.status.status.status;
                ld[this.props.status.id] = this.props.status.loading;
                con[this.props.status.id] = this.props.status.status.contract;
                this.setState({
                    status: st,
                    load: ld,
                    contract: con,
                })
                this.props.addStatusToRecord(this.props.id, {
                    status: st,
                    load: ld,
                    contract: con,
                })
            }
        }
    }

    onClick = (contract) => {
        if (contract) {
            const {match, history} = this.props;
            history.push(`contract/view/${contract._id}`);
        }
    };

    btnText = (contract, label) => {
        if (contract && contract.id) {
            return contract.id;
        } else return label || 'NA'
    };

    render() {
        const {status, load, contract} = this.state;
        return (
            <div style={{width: '50%'}}>
                {
                    this.state.cachedStatus ? <Button style={{width: '100px'}} size={'small'}
                                                      type={this.statusArray[this.state.cachedStatus.status[this.props.id]]}
                                                      shape="round"
                                                      loading={false}
                                                      onClick={() => this.onClick(this.state.cachedStatus.contract[this.props.id])}>{this.btnText(this.state.cachedStatus.contract[this.props.id], label[this.state.cachedStatus.status[this.props.id]])}</Button>
                        :
                        load[this.props.id] === true ? <Skeleton loading={load[this.props.id]}/> :
                            <Button style={{width: '100px'}} size={'small'}
                                    type={this.statusArray[status[this.props.id]]}
                                    shape="round"
                                    loading={label[status[this.props.id]] ? false : true}
                                    onClick={() => this.onClick(contract[this.props.id])}>{this.btnText(contract[this.props.id], label[status[this.props.id]])}</Button>
                }
            </div>
        );
    }
}


const mapStateToProps = ({auth, leasing}) => {
    return {
        authUser: auth.authUser,
        loading: leasing.leasingStatusLoading,
        status: leasing.leasingStatus,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getLeasingStatus
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Status);
